<template>
  <LazyHydrate v-bind="hydrationStrategy">
    <StandardWrapper
      v-bind="$attrs"
      :blok="blok"
      :width="blok.useCardStyle ? 'full' : 'block'"
    >
      <div class="sm:text-center">
        <WidthWrapper
          width="text"
          class="relative"
          :no-padding="!blok.useCardStyle"
        >
          <TitleWithRichText
            :blok="blok"
            :title-class="`sm:text-center ${
              blok.useCardStyle ? 'text-3xl' : ''
            }`"
            subtitle-class="sm:text-center"
            rich-text-class="sm:text-center"
          />
        </WidthWrapper>
      </div>
      <ul
        class="mx-4 mt-12 flex flex-col flex-wrap items-center justify-center sm:mx-8 sm:flex-row sm:items-start md:mx-auto"
        :class="blok.useCardStyle ? 'sm:gap-x-9' : 'sm:gap-x-8'"
      >
        <li
          v-for="contact in blok.contacts"
          :key="contact._uid"
          class="w-full md:w-auto"
          :class="{
            'my-4 rounded-md bg-white drop-shadow-xl sm:my-6':
              blok.useCardStyle,
            'my-6': !blok.useCardStyle,
          }"
        >
          <ContactPerson
            :blok="{
              ...blok,
              bgVariant: blok.useCardStyle ? 'white' : blok.bgVariant,
            }"
            :contact="contact"
            :large="blok.contacts.length === 1"
          />
        </li>
      </ul>

      <div
        v-if="blok.phone || blok.email"
        class="mx-auto flex w-full flex-col items-center justify-center"
        :class="[
          textColorClass(null, blok.bgVariant),
          {
            'mt-10 text-lg': !blok.useCardStyle,
            'mt-6 text-2xl lg:mt-12 lg:text-3xl': blok.useCardStyle,
          },
        ]"
      >
        <div v-if="blok.phoneLabel && blok.phone" :class="linkTextColor">
          {{ blok.phoneLabel }}
          <a
            :href="`tel:${blok.phone}`"
            :aria-label="`Telefoonnummer ${blok.phone}`"
            >{{ blok.phone }}</a
          >
        </div>
        <div v-if="blok.emailLabel && blok.email" :class="linkTextColor">
          {{ blok.emailLabel }}
          <a :href="`mailto:${blok.email}`">{{ blok.email }}</a>
        </div>
      </div>
      <div
        v-if="blok.callToActionButtons && blok.callToActionButtons.length"
        class="mx-auto mt-6 flex w-full flex-col items-center justify-center"
      >
        <CallToActionButtons :blok="blok" />
      </div>
    </StandardWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import StandardWrapper from '../components/StandardWrapper.vue'
import WidthWrapper from '../components/WidthWrapper.vue'
import ContactPerson from '../components/ContactPerson.vue'
import CallToActionButtons from '../components/CallToActionButtons.vue'
import TitleWithRichText from '../components/TitleWithRichText.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass, colorName, isBackgroundDark } = useColorPalette()

const hydrationStrategy = computed(() => {
  return {
    // This block contains a rich text component that has special handling of hash links
    onInteraction: ['focus'],
  }
})
const linkTextColor = computed(() => {
  let colorProp = props.blok.linkTextColor
  if (!colorProp) {
    colorProp = isBackgroundDark(props.blok.bgVariant) ? 'white' : 'default'
  }

  return `richtext-link ${colorName(colorProp)}`
})
</script>
